<template>
  <div v-if="offer.name" :class="styledClass">
    <div class="pdp-default__container">
      <span class="pdp-default__name">{{ getOfferSubName(offer.subName) }}</span>
      <span v-if="offer.subRenewalInfo" ref="subscriptionRenewal" class="subscription__renewal" @click.stop="toggleSubscriptionRenewalDDInfo">
        <span>{{ offer.subRenewalInfo }} <font-awesome-icon ref="infoIcon" :icon="['fas', 'info-circle']" class="fa fa-w-24 subscription__renewal-icon"/></span>
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="subscriptionRenewalDDInfoVisible"
          ref="subscriptionRenewalTooltip"
          class="pdp-default__renewal-tooltip"
          role="tooltip"
          :style="{ '--arrow-left': arrowOffset, '--tooltip-left': tooltipOffset }"
          v-html="subRenewalTooltipInfo"
        ></span>
        <!-- eslint-enable vue/no-v-html -->
      </span>
      <span v-if="offer.subType" class="pdp-default__type">{{ offer.subType }}</span>

      <div v-if="offer.save" class="pdp-default__saving">{{ `Saving ${formatCurrency(offer.rrp - offer.price)}` }}</div>
      <div class="pdp-default__price">
        {{ formatCurrency(offer.price) }}
        <!-- <img
          v-if="offer.freeGiftEnabled && isDefault === '0'"
          :alt="offer.freeGiftDescription"
          class="free-gift"
          src="https://magazine.imgix.net/wysiwyg/free_gift.png?auto=format&fit=fill&fill=solid&bg=0FFF&w=100"
        /> -->
      </div>
    </div>
    <div class="pdp-default__payment-method">
      <div class="payment">
        <PaymentImages
          :is-mobile="true"
          :offer-payment-type="offer.paymentType"
          :is-pdp="styledClass === 'pdp'"
          :is-giftcard="offer.sku === 'gift-card' || offer.sku === 'e-giftcards'"
        />
      </div>
    </div>
    <div v-if="offer.freeGiftEnabled" class="pdp-default__free-gift">
      <span><strong>Free Gift Details</strong></span
      ><br />
      <span class="green-text">{{ offer.freeGiftDescription }}</span>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '~/lib/util/basket'
export default {
  name: 'MobileOfferDefault',
  components: {
    PaymentImages: () => import('~/components/common/product/PaymentImages.vue')
  },
  props: {
    offer: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    magazine: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    isDefault: {
      type: String,
      required: false,
      default() {
        return '0'
      }
    },
    styledClass: {
      type: String,
      required: false,
      default() {
        return 'pdp'
      }
    }
  },
  data() {
    return {
      subscriptionRenewalDDInfoVisible: false,
      subRenewalTooltipInfo: `You can choose to cancel your subscription at any time, including during a trial if one applies, and no further payments will be taken.<br/><br/>Your first Direct Debit payment for the initial price will be collected by ${this.magazine.publisher} shortly after placing your order. Your subscription will then automatically renew by Direct Debit at the frequency shown.`,
      arrowOffset: '0px',
      tooltipOffset: '0px'
    }
  },
  computed: {},
  created() {
    this.$root.$on('desktop-offer-renewal-tooltip-opened', this.handleOtherTooltipOpened)
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    this.$nextTick(() => {
      this.calculateArrowPosition()
    })
    window.addEventListener('resize', this.calculateArrowPosition)
  },
  beforeDestroy() {
    this.$root.$off('desktop-offer-renewal-tooltip-opened', this.handleOtherTooltipOpened)
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('resize', this.calculateArrowPosition)
  },
  methods: {
    calculateArrowPosition() {
      try {
        if (!this.$refs.subscriptionRenewal) return

        const renewal = this.$refs.subscriptionRenewal
        const icon = renewal.querySelector('.subscription__renewal-icon')
        const tooltip = this.$refs.subscriptionRenewalTooltip

        if (!icon) return

        const iconRect = icon.getBoundingClientRect()
        const renewalRect = renewal.getBoundingClientRect()
        const iconCenter = iconRect.left - renewalRect.left + iconRect.width / 2

        const tooltipWidth = tooltip ? tooltip.offsetWidth : 300
        const viewportPadding = 10
        const minLeft = viewportPadding - renewalRect.left
        const maxLeft = window.innerWidth - viewportPadding - renewalRect.left - tooltipWidth

        let tooltipLeft = iconCenter - tooltipWidth / 2
        tooltipLeft = Math.max(minLeft, Math.min(maxLeft, tooltipLeft))

        const rawArrowLeft = iconCenter - tooltipLeft - 5
        const clampedArrowLeft = Math.max(5, Math.min(tooltipWidth - 15, rawArrowLeft))

        this.tooltipOffset = `${tooltipLeft}px`
        this.arrowOffset = `${clampedArrowLeft}px`
      } catch (error) {
        console.error('Error calculating arrow position:', error)
      }
    },
    toggleSubscriptionRenewalDDInfo() {
      const willOpen = !this.subscriptionRenewalDDInfoVisible
      this.subscriptionRenewalDDInfoVisible = willOpen

      if (willOpen) {
        this.$nextTick(() => this.calculateArrowPosition())
        this.$root.$emit('desktop-offer-renewal-tooltip-opened', this._uid)
      }
    },
    handleOtherTooltipOpened(openedByUid) {
      if (openedByUid !== this._uid) {
        this.subscriptionRenewalDDInfoVisible = false
      }
    },
    handleDocumentClick(event) {
      const renewalElement = this.$refs.subscriptionRenewal

      if (!renewalElement || renewalElement.contains(event.target)) {
        return
      }

      this.subscriptionRenewalDDInfoVisible = false
    },
    formatCurrency(value) {
      return formatCurrency(value)
    },
    getOfferSubName(value) {
      if (!value) {
        return ''
      }

      return value.replace(/\s*\((Print & Digital|Digital Edition|Print Edition|Membership)\)\s*$/i, '').trim()
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: $screen-xs-max) {
  .pdp-default {
    &__container {
      flex: 1 1 50%;
      display: flex;
      flex-flow: column;
    }
    &__name {
      font-weight: 600;
      color: #666;
      font-size: 12px;
    }
    &__renewal {
      position: relative;
      display: inline-block;
      font-size: 11px;
      font-weight: 400;
      color: #353535;
      cursor: pointer;
    }
    &__price {
      color: #e20c0b;
      font-size: 24px !important;
      font-weight: 700 !important;
      margin: 10px 0;
    }
    &__renewal-tooltip {
      position: absolute;
      top: calc(100% + 6px);
      left: var(--tooltip-left, 0);
      z-index: 10;
      width: 300px;
      max-width: calc(100vw - 20px);
      padding: 15px;
      border-radius: 4px;
      font-size: 11px;
      line-height: 1.3;
      color: #fff;
      background-color: #666666;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      white-space: normal;
    }
    &__renewal-tooltip::before {
      content: '';
      position: absolute;
      top: -5px;
      left: var(--arrow-left, 0);
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid #666666;
    }
    &__renewal-icon {
      background-color: #fff;
      color: #a1a1a1;
      border-radius: 50%;
    }
    &__type {
      font-size: 11px;
      font-weight: 600;
      color: #353535;
    }
    &__payment-method {
      display: flex;
      flex-flow: column;
      align-items: left;
      justify-content: center;
      flex: 1 1 25%;
    }
    &__free-gift {
      flex: 1 1 100%;
      padding: 0px 10px 10px 0px;
      font-size: 14px;
      border-top: unset;
    }
    &__saving {
      color: #666;
      font-size: 16px;
      font-weight: 700;
    }
  }
}
</style>
